<div class="activity-button mat-elevation-z2">

  <p>{{ 'profile.upload-button' | translate }}</p>

  <div class="activity-button--action">
    <div class="activity-button--action-button" matRipple>{{ 'profile.add' | translate }}</div>
  </div>

</div>
